export default __webpack_public_path__ + "static/media/Yarn.f51701f1.png";